<h2 class="iackathon-step-how-now-wow__title">
    <mat-icon svgIcon="tile-small-rounded"></mat-icon>
    <span>{{'iackathon.ideas' | translate}}</span>
</h2>

<mat-accordion class="iackathon-step-how-now-wow__accordion">
    @for (slot of [
        {ideas: conventionalImpossible(), labelKey: 'iackathon.conventional_impossible'},
        {ideas: conventionalPossible(), labelKey: 'iackathon.conventional_possible'},
        {ideas: originalImpossible(), labelKey: 'iackathon.original_impossible'},
        {ideas: originalPossible(), labelKey: 'iackathon.original_possible'}
    ]; track slot.labelKey) {
        <mat-expansion-panel class="iackathon-step-how-now-wow__panel"
                             [disabled]="!slot.ideas.length">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <span class="iackathon-step-how-now-wow__idea-number-tag">
                        {{ slot.ideas.length }}</span>
                    <span class="iackathon-step-how-now-wow__idea-label">
                        {{ slot.labelKey | translate }}
                    </span>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <ul class="iackathon-step-how-now-wow__idea-list">
                @for (idea of slot.ideas; track idea.idea) {
                    <li class="iackathon-step-how-now-wow__idea-item">
                        {{ idea.idea }}
                    </li>
                }
            </ul>
        </mat-expansion-panel>
    }
</mat-accordion>